import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { ThreeBounceSpinner } from '../Global/LoadingSpinner'
import {
    LoadingWrapper,
    LoadingTextWrapper
} from '../StyledComponents/Classifier/LoadingScreen'
import { QuestionBackLink } from '../StyledComponents/IntroQuestions/Question'
import InfoModal from '../Global/InfoModal'
import { FillerDiv } from '../StyledComponents/Fillers'
import { classifyPlant, loadTFModel, resetClassifyImage } from '../../actions'
import { CLASSIFIER, PLANT } from '../../constants/routes'

class PlantClassification extends Component {
    constructor(props) {
        super(props)

        this.state = {
            notReliable: false,
        }

        this.backClicked = this.backClicked.bind(this)
    }

    componentDidMount() {
        const { image } = this.props

        if (this.props.recognizedPlant) {
            this.props.history.push(PLANT.replace(':id', this.props.recognizedPlant))
            return
        }

        if (this.props.model && image) {
            setTimeout(() => { this.props.classifyPlant(this.props.model, image) }, 10)
        }

        if (!this.props.model) {
            this.props.loadTFModel()
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.recognizedPlant) {
            if (newProps.reliability && newProps.reliability < 0.7) {
                this.setState({ notReliable: true })
                return
            }
            this.props.history.push(PLANT.replace(':id', newProps.recognizedPlant))
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.model && this.props.model && this.props.image) {
            this.props.classifyPlant(this.props.model, this.props.image)
        }
    }

    backClicked() {
        this.props.history.goBack()
    }

    render() {
        const { image, history, resetClassification } = this.props

        let infoModal = ''
        if (!image) {
            infoModal = (
                <InfoModal
                    text="Mache ein Foto deiner Pflanze, um sie zu klassifizieren."
                    headerText="Kein Bild ausgewählt"
                    isOpen
                    closeModal={() => history.push(CLASSIFIER)}
                />
            )
        } else if (this.state.notReliable) {
            infoModal = (
                <InfoModal
                    text="Für dieses Foto konnte keine vernünftige Klassifizierung vorgenommen werden. Versuche es mit einem anderen Bild"
                    headerText="Keine Pflanze erkannt"
                    isOpen
                    closeModal={() => {
                        resetClassification()
                        history.push(CLASSIFIER)
                    }}
                />
            )
        }

        const backLink = (
            <QuestionBackLink onClick={this.backClicked} >
                <FontAwesome
                    name="close"
                    size="lg"
                />
            </QuestionBackLink>
        )

        return (
            <FillerDiv>
                {infoModal}
                {backLink}
                <LoadingTextWrapper>Das Bild wird analysiert...</LoadingTextWrapper>
                <LoadingWrapper><ThreeBounceSpinner /></LoadingWrapper>
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    recognizedPlant: state.classifier.recognizedPlant,
    reliability: state.classifier.reliability,
    image: state.classifier.image,
    model: state.tensorflowModel.model,
})

export default compose(
    withRouter,
    connect(mapStateToProps, {
        classifyPlant,
        loadTFModel,
        resetClassification: resetClassifyImage,
    })
)(PlantClassification)



// WEBPACK FOOTER //
// ./src/components/pages/PlantClassification.js